import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useWizard } from "components/wizard/WizardContext";
import ALoader from "views/pages/manage/common/a-loader";
import _ from "lodash";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { SEARCH_BY, vendorDetailsLabelFieldMapping } from "../helper";
import styles from "../styles.module.scss";
import Footer from "modules/studentRefund/completionRefund/reinitiate/components/Footer";
import { useFetchVendorData } from "../customHook";
import VendorDetails from "./VendorDetails";
import { defaultStreamValues } from "../config"
import ASearchableSelect from "views/pages/manage/common/form-fields-mui/ASearchableSelect";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddDetails = ({ isShowFooter = true, readOnly = false }) => {
    const { values, updateValues, dropdowns, next } = useWizard();
    const { fetchVendorData } = useFetchVendorData();
    const { vendorDetails } = values;
    const { businessAreas, year, allVendors } = dropdowns?.data;
    const [form, setForm] = useState(values?.addVendorForm ?? {});
    const [filters, setFilters] = useState({
        searchBy: "",
        searchByValue: "",
    });

    const [userSearchInput, setUserSearchInput] = useState("");
    const [selectedSearchInputOption, setSelectedSearchInputOption] = useState("vendorName");
    const [vendorOptions, setVendorOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = (val, key) => {
        if (readOnly) return;

        setForm((prev) => {
            const updated = { ...prev, [key]: val };
            updateValues("addVendorForm", updated);
            return updated;
        });
    };

    const handleCheckDetails = () => {
        if (readOnly) return;

        updateValues("SOF", { ...defaultStreamValues });
        updateValues("SOM", { ...defaultStreamValues });
        updateValues("SOE", { ...defaultStreamValues });

        fetchVendorData(form);
    };

    const isCheckDisabled = !form?.businessArea || !form?.year || !form?.vendorId || readOnly;

    const searchInputHandler = async (value = userSearchInput) => {
        if (!value?.trim()) {
            setVendorOptions([]);
            return;
        }

        const updatedFilters = {
            ...filters,
            searchBy: value ? selectedSearchInputOption : "",
            searchByValue: value,
        };

        setFilters(updatedFilters);
        setIsLoading(true);
        try {
            const url = `${endpoint.vendorManagement.getAll}?searchValue=${encodeURIComponent(value)}`;

            const resp = await fetchAllPromisedData(url, true);

            if (resp?.code === 200) {
                const formattedOptions = resp?.data?.map((item) => ({
                    label: item.vendorName,
                    value: item.vendorSapCode,
                    id: item?.id
                })) || [];
                setVendorOptions(formattedOptions);
            } else {
                setVendorOptions([]);
            }
        } catch (err) {
            console.error("Vendor search failed:", err);
            setVendorOptions([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOnUserInput = (value) => {
        setUserSearchInput(value);
        if (value === "" && value !== filters.searchByValue)
            searchInputHandler(value);
    };

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            searchInputHandler();
        }
    };

    return (
        <>
            {(dropdowns?.loading || values?.vendorDetailsLoading) && <ALoader position={"fixed"} />}
            <div style={{ paddingBottom: isShowFooter ? "120px" : "20px" }}>

                <Card style={{ margin: "15px" }}>
                    <div className={styles['dropdown-container']}>
                        <div className={styles['label']}>Add Details</div>
                        <div className={styles['dropdowns']}>
                            <ASearchableSelect
                                label="Vendor ID"
                                userSearchInput={userSearchInput}
                                setUserSearchInput={setUserSearchInput}
                                onKeyDownHandler={onKeyDownHandler}
                                handleOnUserInput={handleOnUserInput}
                                selectedOption={form?.vendorId}
                                setSelectedOption={(value) => {
                                    handleForm(value, "vendorId")
                                }}
                                searchInputHandler={searchInputHandler}
                                items={vendorOptions}
                                loading={isLoading}
                                isMulti={false}
                                searchByOptions={SEARCH_BY}
                                selectedSearchInputOption={selectedSearchInputOption}
                                setSelectedSearchInputOption={setSelectedSearchInputOption}
                                placeholder="Select"
                                inputStyle={{ width: "100%" }}
                                noResultsText="No Vendor Available"
                            />
                            <AAutoComplete
                                label='Business Unit'
                                labelStyle={labelStyle}
                                currentValue={form?.businessArea}
                                handleChange={(value) => {
                                    handleForm(value, "businessArea")
                                }}
                                items={businessAreas}
                                isMulti={false}
                                placeholder={"Select"}
                                isDisabled={readOnly}
                            />
                            <AAutoComplete
                                label='Year'
                                labelStyle={labelStyle}
                                currentValue={form?.year}
                                handleChange={(value) => {
                                    handleForm(value, "year")
                                }}
                                items={year}
                                isMulti={false}
                                placeholder={"Select"}
                                isDisabled={readOnly}
                            />

                            <div className={styles['buttonWrapper']}>
                                <AButton
                                    variant="primary_filled"
                                    onClick={handleCheckDetails}
                                    size="xs"
                                    disabled={isCheckDisabled}
                                >
                                    Check Details
                                </AButton>
                            </div>

                        </div>
                    </div>
                </Card>

                {!_.isEmpty(vendorDetails) &&
                    <Card style={{ margin: "15px" }}>
                        <VendorDetails
                            vendorDetails={vendorDetails}
                            labelFieldMappings={vendorDetailsLabelFieldMapping()}
                        />
                    </Card>
                }
            </div>
            {isShowFooter &&
                <Footer>
                    <div>Raise a payment request</div>
                    <AButton
                        disabled={_.isEmpty(vendorDetails)}
                        onClick={() => { next(); }}
                        className="button_remove_left_margin"
                        variant="primary_filled"
                    >
                        Proceed next
                    </AButton>
                </Footer>
            }
        </>
    )
}

export default AddDetails